import { render, staticRenderFns } from "./ProductionOrdersDetails.vue?vue&type=template&id=1bf4dd68&scoped=true&"
import script from "./ProductionOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./ProductionOrdersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrdersDetails.vue?vue&type=style&index=0&id=1bf4dd68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4dd68",
  null
  
)

export default component.exports